import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withStyles, Grid, Button } from '@material-ui/core';
import buttonImage from '../resources/Images/take_the_quiz.png'

const styles = theme => ({
    wrapper: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: '5%'
    },
    h1: {
        fontSize: '3.5em',
        fontWeight: '600',
        width: '100%',
        textAlign: 'center'
    },
    p: {
        fontWeight: '300',
        textAlign: 'center'
    },
    box: {
        width: "950px !important"
    },
    button: {
        '&:hover': {
            opacity: '0.7 !important',
            backgroundColor: 'transparent'
        }
    }
});

class HomeComponent extends Component {
    render() {
        const { classes, history } = this.props;
        return (
            <div className={classes.wrapper}>
                <Grid container className={classes.box}>
                    <Grid container item xs={12} justify="center">
                        <h1 className={classes.h1}>What's your design style?</h1>
                        <Button
                            size="small"
                            className={classes.button}
                            onClick={e => {
                                history.push(`/steps`);
                            }}>
                            <img src={buttonImage} style={{maxWidth:'350px'}} size="tidy" alt="icon export" />
                        </Button>
                        <p className={classes.p} style={{ marginBottom: '0' }}>Select the images to which you’re most drawn. Think vibe. Shape. Mood. Inspiration. The overall look.</p>
                        <p className={classes.p} style={{ width: '100%', marginTop: '0' }}> Don’t linger – just go with your instincts.</p>
                        <p className={classes.p}>(If you are shopping for someone else, pick what you think they would choose.)</p>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

HomeComponent.propTypes = {
    onInputValueChange: PropTypes.func
};

export default withStyles(styles)(HomeComponent);

